<template>
  <div>
    <load-profile></load-profile>
    <!-- Search Container Card -->
    <n-search-container
      @search="search"
      @reset="reset"
      :fields="searchFields"
      :default-visible="true"
    >
      <n-search-input ref="search" :fields="searchFields" v-model="params">
        <template #startDate>
          <div v-if="params.period != 'other'"></div>
        </template>
        <template #endDate>
          <div v-if="params.period != 'other'"></div>
        </template>
      </n-search-input>
    </n-search-container>

    <b-row>
      <b-col md="12" lg="8">
        <coming-call-line-chart
          ref="comingChart"
          :loading="loading"
          :chart-data="comingChart"
        ></coming-call-line-chart>
        <!-- <response-time-bar-chart ref="responseTimeChart" :loading="loading"
          :chart-data="responseTimeChart"></response-time-bar-chart>
        <call-duration-bar-chart ref="conversationDurationChart" :loading="loading"
          :chart-data="conversationDurationChart"></call-duration-bar-chart> -->
      </b-col>
      <b-col md="12" lg="4">
        <!-- <StatisticCardHorizontal :loading="loading" :statistic="data.openConversation" :title="$t('overviewReport.open')"
          :description="$t('overviewReport.openDescription')" color="info" :query="{
            ...params,
            filter: 'unresolved',
            type: 'allConversation',
            cache: 'no',
          }" />
        <StatisticCardHorizontal :loading="loading" :statistic="data.resolvedConversation"
          :title="$t('overviewReport.closed')" :description="$t('overviewReport.closedDescription')" color="success"
          :query="{
            ...params,
            filter: 'resolved',
            type: 'allConversation',
            cache: 'no',
          }" />
        <StatisticCardHorizontal :loading="loading" :statistic="data.blockedConversation"
          :title="$t('overviewReport.blocked')" :description="$t('overviewReport.blockedDescription')" color="danger"
          :query="{
            ...params,
            filter: 'banned',
            type: 'allConversation',
            cache: 'no',
          }" /> -->
        <StatisticCardHorizontal
          :loading="loading"
          :statistic="totalConversation"
          :title="$t('overviewReport.total')"
          :description="$t('overviewReport.totalCallDescription')"
          :is-call="true"
          color="primary"
          routeName="call"
          :query="{
            ...params,
            type: 'allConversation',
            filter: 'noCache',
            cache: 'no',
          }"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BCard, BRow, BCol } from "bootstrap-vue";

import StatisticCardHorizontal from "@/views/dashbaord/StatisticCardHorizontal.vue";
import ComingCallLineChart from "@/views/callCenterOverview/ComingCallLineChart.vue";
import CallDurationBarChart from "@/views/callCenterOverview/CallDurationBarChart.vue";
import ResponseTimeBarChart from "@/views/callCenterOverview/ResponseTimeBarChart.vue";

import NSearchContainer from "@/components/NSearchContainer";
import NSearchInput from "@/components/NSearchInput";
import SearchInputs from "./searchInput";
import Repository from "@/repositories/RepositoryFactory";
import { calculateDatesByPeriod } from "@/libs/helper";
import useJwt from "@/auth/jwt/useJwt";

const ReportRepository = Repository.get("report");

export default {
  components: {
    BCard,
    BRow,
    BCol,
    NSearchContainer,
    NSearchInput,
    StatisticCardHorizontal,
    ResponseTimeBarChart,
    ComingCallLineChart,
    CallDurationBarChart,
  },
  computed: {
    totalConversation() {
      console.log(this.data.totalComingCall);
      return this.data.totalComingCall;
    },
    userData: function () {
      return this.$store.state.profile.email || this.$store.state.profile.phone  
        ? this.$store.state.profile
        : JSON.parse(
            localStorage.getItem(useJwt.jwtConfig.storageUserDataKeyName)
          );
    },
  },
  watch: {
    "params.period": function (value) {
      this.calculateDate();
    },
  },
  data() {
    return {
      data: {
        blockedConversation: 0,
        openConversation: 0,
        resolvedConversation: 0,
        totalComingCall: 0,
      },
      comingChart: {},
      responseTimeChart: {},
      conversationDurationChart: {},
      loading: false,
      params: {
        period: this.$route.query.period || "thisWeek",
        operator: this.$route.query.operator || null,
        startDate: this.$route.query.startDate || null,
        endDate: this.$route.query.endDate || null,
      },
    };
  },
  mounted() {
    this.index();
  },
  methods: {
    calculateDate() {
      let dates;
      if (this.params.period == "other") {
        dates = calculateDatesByPeriod("thisWeek");
      } else {
        dates = calculateDatesByPeriod(this.params.period);
      }
      if (dates.length) {
        this.params.startDate = dates[0];
        this.params.endDate = dates[1];
      }
    },
    changeDate(period) {
      this.params.period = period;
      this.updateQuerySting();
    },
    updateQuerySting() {
      this.$router.replace({ query: { ...this.params, type: this.$route.query.type } });
      this.index();
    },
    search() {
      this.updateQuerySting();
    },
    reset() {
      this.$refs.search.reset();
      this.params.period = "thisWeek";
      this.calculateDate();
      this.updateQuerySting();
    },
    index() {
      this.loading = true;
      if (!this.params.startDate || !this.params.endDate) {
        this.calculateDate();
      }
      ReportRepository.index({
        ...this.params,
      })
        .then((response) => {
          const data = response?.data?.data;
          if (data) {
            this.data.totalComingCall = data.totalComingCall;
            this.data.blockedConversation = data.blockedConversation;
            this.data.openConversation = data.openConversation;
            this.data.resolvedConversation = data.resolvedConversation;
            this.comingChart = {
              ...data.comingChart,
            };
            this.$refs.comingChart.mapChartData(data.comingChart);

            this.responseTimeChart = {
              ...data.chartResponseDuration,
            };
            this.$refs.responseTimeChart.mapChartData(
              data.chartResponseDuration
            );

            this.conversationDurationChart = {
              ...data.chartChatDuration,
            };
            this.$refs.conversationDurationChart.mapChartData(
              data.chartChatDuration
            );
          }
        })
        .catch((error) => {})
        .then(() => {
          this.loading = false;
        });
    },
  },
  setup() {
    const searchFields = SearchInputs;
    return {
      searchFields,
    };
  },
};
</script>
